import S from '../../lib/translations';

if (window.__uniqueTextsToTranslate === undefined) {
  window.__uniqueTextsToTranslate = new Set();
}

function getLocalTemplate(lang: string, text: string): string {
  window.__uniqueTextsToTranslate.add(text);
  if (!S[lang as keyof typeof S]) {
    return text;
  }
  const translations = S[lang as keyof typeof S] as Record<string, string>;
  return translations[text] || text;
}

export default (lang: string, text: string, params: Array<string | number> = []): string => {
  let template = getLocalTemplate(lang, text);
  for (let i = 0; i < params.length; i++) {
    template = template.replaceAll(`{${i}}`, String(params[i]));
  }
  return template;
};
